<template>
    <div>
        <van-row class="center">
            <van-col :span="6">
                <van-tag round :type="activate==0 ? 'primary' : 'default'" size="large" @click="search(0)">近半年</van-tag>
            </van-col>
            <van-col :span="6">
                <van-tag round :type="activate==1 ? 'primary' : 'default'" size="large" @click="search(1)">近一年</van-tag>
        </van-col>
        <van-col :span="6">
                <van-tag round :type="activate==2 ? 'primary' : 'default'" size="large" @click="search(2)">近三年</van-tag>
        </van-col>
        <van-col :span="6">
                <van-tag round :type="activate==3 ? 'primary' : 'default'" size="large" @click="search(3)">三年前</van-tag>
        </van-col>
        </van-row>

        <van-list>
            <van-cell
                v-for="item in data"
                :key="item.id"
                :title="item.source_style_name"
                title-style="color:#007acc;font-weight:bold;"
                >
                <div slot="label" class="van-ellipsis">
                    <div><strong>产生日期:</strong>{{ item.create_date }}</div>
                    <div><strong>相关单号:</strong>{{ item.source_no }}</div>
                    <div><strong>实际金额:</strong>{{ item.real_payment }}</div>
                </div>
                <template #default>
                    <div style="font-weight:bold;color:#666666;">{{item.amount>0?('+')+item.amount:item.amount}}</div>
                    <div style="margin-top:20%;font-weight:bold;color:#007acc;">余额：{{item.amount_available}}</div>
                </template>
            </van-cell>
        </van-list>
    </div>

</template>

<script>
import {NavBar, Row, Col, Tag, List, Cell} from 'vant'
import { getCurDate, getEndData } from '@/utils/dateutils'
import { AssertDetailApi } from '@/api/market'
export default {
    name: 'StoredCardItems',
    components: {
        [NavBar.name]: NavBar,
        [Row.name]: Row,
        [Col.name]: Col,
        [Tag.name]: Tag,
        [List.name]: List,
        [Cell.name]: Cell
    },
    data() {
        return {
            hasstoredvaluecard: false,
            activate: 0,
            loading: false,
            data: [],
            query: {
                style:null,
                id: null,
                begin_date: getCurDate(),
                end_date: null
            }
        }
    },
    mounted() {
        // console.log(this.$route)
        // console.log(this.$route.query)
        // this.query.style = this.$route.query.style
        // this.query.id = this.$route.query.id
        // console.log(this.query)
        // this.getdata()
    },
    methods: {
        showdetails(id) {
            this.query.id = id
            this.getdata(id)
        },
        search(idx) {
            this.activate = idx
            this.getdata()
        },
        getdata() {
            this.loading = true
            this.query.end_date = getCurDate()
            switch (this.activate) {
                case 0:
                    this.query.begin_date = getEndData(0, -6, 0)
                    break;
                case 1:
                    this.query.begin_date = getEndData(-1, 0, 0)
                    break;
                case 2:
                    this.query.begin_date = getEndData(-3, 0, 0)
                    break;
                case 3:
                    this.query.end_date = getEndData(-3, 0, 0)
                    this.query.begin_date = null
                    break;
            }
            const params = {
                style: 'storecard',
                id: this.query.id,
                begin_date: this.query.begin_date,
                end_date: this.query.end_date
            }
            var that = this
            this.axios.get(AssertDetailApi, { params: params}).then((ret) => {
                console.log('items')
                console.log(ret)
                that.loading = false
                that.data = ret.details
                that.data.forEach((it) => {
                    it.create_date = this.$moment(it.create_date).format('YYYY-MM-DD HH-mm')
                })
            })
        }
    }
}
</script>

<style scoped>
.center {
    text-align: center;
}
</style>